<div  fxLayoutGap="5px" class="padding-top-xs">
  @for (meter of completionMeter; track meter) {
    <div class="rectangle" [ngClass]="meter.active ? meter.value : ''"></div>
  }
</div>
<mat-icon class="margin-left-sm" [svgIcon]="completionIcon"></mat-icon>
